import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { toast } from "@/components/Toast";
import { ArrowLeft, Check, AlertTriangle, MapPin, Clock } from "lucide-react";
import { PATROL_STATUS_LABEL, SCAN_STATUS_LABEL } from "@/lib/i18n";
import { AttachmentGrid } from "@/components/AttachmentPicker";

export default function VigiladorPatrolView() {
  const { id } = useParams();
  const [p, setP] = useState(null);

  useEffect(() => {
    (async () => {
      try { const { data } = await api.get(`/patrols/${id}`); setP(data); }
      catch (e) { toast.error(formatApiError(e)); }
    })();
  }, [id]);

  if (!p) return <div style={{ padding: 16 }}><div className="skel" style={{ height: 120 }} /></div>;

  return (
    <div style={{ padding: "8px 12px" }}>
      <Link to="/vigilador" style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "var(--invict-text-muted)", fontSize: 12, marginBottom: 12, textDecoration: "none", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.05em" }}><ArrowLeft size={14}/> Volver</Link>

      <div style={{ background: p.status === "completada" ? "#16a34a" : "#0A0A0A", color: "#FFFBF4", padding: "18px", borderRadius: 4, marginBottom: 14 }}>
        <div style={{ fontSize: 11, letterSpacing: "0.2em", fontWeight: 700, textTransform: "uppercase", marginBottom: 6, opacity: 0.85 }}>{p.client_name}{p.site_name ? ` · ${p.site_name}` : ""}</div>
        <div style={{ fontSize: 24, fontWeight: 900, lineHeight: 1, marginBottom: 6 }}>
          {p.points_completed}/{p.total_points} <span style={{ fontSize: 13, opacity: 0.6, fontWeight: 600 }}>puntos</span>
        </div>
        <div style={{ fontSize: 11, opacity: 0.8, display: "flex", gap: 12, flexWrap: "wrap" }}>
          <span><Clock size={11} style={{ display: "inline", marginRight: 3 }}/>{new Date(p.scheduled_for).toLocaleString("es-AR")}</span>
          <span style={{ textTransform: "uppercase", fontWeight: 700 }}>{PATROL_STATUS_LABEL[p.status] || p.status}</span>
          {p.anomalies > 0 && <span><AlertTriangle size={11} style={{ display: "inline", marginRight: 3 }}/>{p.anomalies} anomalía(s)</span>}
        </div>
      </div>

      <div style={{ fontSize: 11, fontWeight: 800, textTransform: "uppercase", letterSpacing: "0.1em", color: "#0A0A0A", marginBottom: 8 }}>Recorrido</div>
      <div className="card" style={{ padding: 0, overflow: "hidden" }}>
        {p.points.map((pt) => {
          const scan = p.scans.find((s) => s.patrol_point_id === pt.id);
          return (
            <div key={pt.id} style={{ padding: "12px 16px", borderBottom: "1px solid var(--invict-bone-3)", display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ width: 30, height: 30, borderRadius: "50%", background: scan ? (scan.status === "ok" ? "#16a34a" : "#BF3437") : "var(--invict-bone-3)", color: scan ? "white" : "#6B655A", display: "grid", placeItems: "center", flexShrink: 0, fontWeight: 800, fontSize: 12 }}>
                {scan ? (scan.status === "ok" ? <Check size={14}/> : <AlertTriangle size={14}/>) : pt.order}
              </div>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 13, fontWeight: 800, color: "#0A0A0A" }}>{pt.name}</div>
                {scan ? (
                  <div>
                    <div style={{ fontSize: 10, color: "var(--invict-text-muted)" }}>{new Date(scan.scanned_at).toLocaleTimeString("es-AR")} · {scan.gps_degraded ? "sin señal GPS" : `${scan.distance_meters}m`} · {SCAN_STATUS_LABEL[scan.status] || scan.status}{scan.offline_sync ? " · offline" : ""}</div>
                    {scan.gps_degraded && <div style={{ fontSize: 10, color: "#BF3437", fontWeight: 700 }} data-testid={`scan-degraded-${scan.id}`}>Verificado por foto/video (sin señal)</div>}
                    {scan.attachments?.length > 0 && <AttachmentGrid items={scan.attachments} />}
                  </div>
                ) : (
                  <div style={{ fontSize: 10, color: "var(--invict-text-muted)" }}><MapPin size={9} style={{ display: "inline", marginRight: 3 }} />{pt.latitude.toFixed(5)}, {pt.longitude.toFixed(5)} · No escaneado</div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
